import { Component, Input, OnChanges } from '@angular/core';

/**
 * Component that highlights parts of a text that matches a selected text
 */
@Component({
    selector: 'cw-text-highlight',
    templateUrl: './text-highlight.component.html',
    styles: [],
    standalone: false,
})
export class TextHighlightComponent implements OnChanges {
    /**
     * Text to look for the selected text
     */
    @Input() text = '';

    /**
     * Text to be highlighted
     */
    @Input() selectedText: string | null = '';

    /**
     * Background color of the highlighted text
     */
    @Input() selectedBgColor = 'var(--twc-topcon-blue)';

    /**
     * Color of the highlighted text
     */
    @Input() selectedColor = 'var(--twc-white)';

    textParts: Array<{ text: string; isHighlighted: boolean }> = [];

    ngOnChanges(): void {
        if (this.text && this.selectedText) {
            let areSomeHighlighted = false;
            this.textParts = this.text
                .split(new RegExp(`(${this.selectedText})`, 'i'))
                .filter((str) => !!str)
                .map((str) => {
                    const hasText = str.toLowerCase() === this.selectedText?.toLowerCase();
                    const part = {
                        text: str,
                        isHighlighted: areSomeHighlighted ? false : hasText,
                    };
                    areSomeHighlighted = areSomeHighlighted || hasText;
                    return part;
                });
        } else {
            this.textParts = [{ text: this.text, isHighlighted: false }];
        }
    }

    /**
     * Returns the style of the text part
     * @param isHighlighted Tells if the text part is highlighted
     */
    getPartStyle(isHighlighted: boolean): { [key: string]: string } {
        return isHighlighted
            ? {
                  'background-color': `${this.selectedBgColor}`,
                  color: `${this.selectedColor}`,
                  'border-radius': '4px',
              }
            : {};
    }
}
